import { Link } from "react-router-dom"
import { footer } from "../content/footer"

export default function Footer() {
    return (
        <footer style={{
            borderTop: "1px solid #E5E7EB",
            padding: "48px 32px",
            maxWidth: 1280,
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 24,
        }}>
            <div>
                <div style={{ fontSize: 22, fontWeight: 800, color: "#111827", marginBottom: 6 }}>
                    {footer.brand}
                </div>
                <div style={{ fontSize: 15, color: "#9CA3AF" }}>
                    {footer.tagline}
                </div>
            </div>

            <div style={{ display: "flex", gap: 24, flexWrap: "wrap", alignItems: "center" }}>
                {footer.links.map((link) => (
                    <Link key={link.href} to={link.href} style={{
                        fontSize: 15, color: "#6B7280",
                        textDecoration: "none", fontWeight: 500,
                    }}>
                        {link.label}
                    </Link>
                ))}
                <span style={{ fontSize: 14, color: "#D1D5DB" }}>
                    {footer.copyright}
                </span>
            </div>
            <div style={{ width: "100%", borderTop: "1px solid #F3F4F6", paddingTop: 20, marginTop: 8 }}>
                <p style={{ fontSize: 12, color: "#9CA3AF", margin: 0, lineHeight: 1.6 }}>
                    Qwiztime is an independent practice platform. Not affiliated with or endorsed by AAPC or any certification body.
                    CPC-style questions are original and created for educational purposes only. "CPC" and "Certified Professional Coder"
                    are trademarks of AAPC. Use of these terms is for descriptive purposes only.
                    Currently available in the United States only. If you are in the US and cannot access the site, please disable your VPN.
                </p>
            </div>
        </footer>
    )
}
